export default function EmbedController(
  $scope,
  $timeout,
  $location,
  CreativeFromParamFactory,
  CreativeService,
  DataService,
  RenderService,
  SitesService
) {
  return Promise.resolve()
    .then(() => {
      const creativeId = $location.search().creativeId;
      if (creativeId) {
        return DataService.getCreative(creativeId).then(({ data }) => data);
      } else {
        return CreativeFromParamFactory.build();
      }
    })
    .then(creative => {
      CreativeService.setCreative(creative);

      // we can't rely on the angular routing to set partner sites for
      // us (embed is a pure rails route)
      return SitesService.fetchPartnerSites();
    })
    .then(partnerSites => {
      RenderService.site = SitesService.fromSearchParams() || partnerSites[0];

      $timeout(() => {
        $scope.$broadcast('updatePreview');
      });
    })
    .catch(err => console.error(err)); // eslint-disable-line no-console
}

EmbedController.$inject = [
  '$scope',
  '$timeout',
  '$location',
  'CreativeFromParamFactory',
  'CreativeService',
  'DataService',
  'RenderService',
  'SitesService'
];
